import { Component } from '@angular/core';
import { NavController,LoadingController,ModalController, AlertController, NavParams,ViewController } from 'ionic-angular';

import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import '../../../node_modules/moment/locale/es';
import { Params } from '../params';
import { CancellationsPage } from './cancellations';

@Component({
 selector: 'page-cancellate',
 templateUrl: 'cancellate.html'
})
export class CancellatePage{
 customers : any;
 // customersRef: FirebaseListObservable<any>;
  items = [];
 constructor(
 public modalCtrl: ModalController,
 private navCtrl : NavController,
 ){
   firebase.database().ref('/customers').once('value').then((snap)=>{
     if(snap.exists()){
       const val = snap.val();
       this.customers = Object.keys(val).map(key => val[key]);
       this.initializeItems();
       if(this.items.length>100){this.items = this.items.splice(0,100);}
     }
   })
 }
  initializeItems(){
    let cloned = this.customers.map(x => Object.assign({}, x));
    this.items = cloned;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (
          (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      })
    }
    if(this.items.length>100){this.items = this.items.splice(0,100);}
  }

 open(customer){
   console.log(customer);
  let modal = this.modalCtrl.create(SelectDaysPage, customer);
   modal.onDidDismiss(data => {
     this.navCtrl.pop();
   });
  modal.present();
 }
}
@Component({
  template: `
<ion-header>
  <ion-toolbar>
    <ion-title>
      Suspender días a {{customer.name}}
    </ion-title>
    <ion-buttons end>
      <button ion-button [disabled]="!addForm.valid" (click)="save()">
        Guardar Suspensión
      </button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
  <form [formGroup]="addForm" (ngSubmit)="onSubmit(addForm)">
    <ion-item>
      <ion-label>Tipo de Suspensión</ion-label>
      <ion-select formControlName="kind" name="kind">
        <ion-option value="1">Un día</ion-option>
        <ion-option value="2">Varios días seguidos</ion-option>
        <ion-option value="3">Varios días por separado</ion-option>
      </ion-select>
    </ion-item>
    <ion-item *ngIf="addForm.value.kind==1">
      <ion-label>Día</ion-label>
      <ion-datetime [min]="today" [max]="max" formControlName="day" name="day" displayFormat="DD MMMM YY" pickerFormat="DD MMMM YY" doneText="Aceptar"></ion-datetime>
    </ion-item>
    <div *ngIf="addForm.value.kind==3">
      <ion-item *ngFor="let d of days; let i = index">
        <ion-label>Día {{i+1}} </ion-label>
        <ion-datetime [min]="today" [max]="max" [(ngModel)]="days[i]"  [ngModelOptions]="{standalone: true}" name="day" displayFormat="DD MMMM YY" pickerFormat="DD MMMM YY" doneText="Aceptar"></ion-datetime>
        <div item-end>
          <button ion-button type="button" color="danger" (click)="delDay(i)">x</button>
        </div>
      </ion-item>
      <ion-item>
        <button type="button" ion-button (click)="addDay()">Agregar día {{days.length+1}}</button>
      </ion-item>
    </div>
    <ion-item *ngIf="addForm.value.kind==2">
      <ion-label>Desde</ion-label>
      <ion-datetime [min]="today" [max]="max" formControlName="from" name="from" displayFormat="DD MMMM YY" pickerFormat="DD MMMM YY" doneText="Aceptar"></ion-datetime>
    </ion-item>
    <ion-item *ngIf="addForm.value.kind==2">
      <ion-label>Retorno</ion-label>
      <ion-datetime [min]="today" [max]="max" formControlName="to" name="to" displayFormat="DD MMMM YY" pickerFormat="DD MMMM YY" doneText="Aceptar"></ion-datetime>
    </ion-item>
    <ion-item *ngIf="addForm.value.kind">
        <ion-label>Motivo</ion-label>
        <ion-select formControlName="reason" name="reason">
          <ion-option value="PE">Personal</ion-option>
          <ion-option value="VA">Vacaciones</ion-option>
          <ion-option value="FE">Festivo</ion-option>
          <ion-option value="NP">No Pago</ion-option>
        </ion-select>
    </ion-item>
    <ion-item *ngIf="addForm.value.kind">
      <ion-label>Observaciones</ion-label>
      <ion-textarea rows="3" formControlName="obs" name="obs"></ion-textarea>
    </ion-item>
  </form>
  </ion-list>
</ion-content>
`
})
export class SelectDaysPage {
  addForm: FormGroup;
  customer;
  today;
  max;
  days = [];
  constructor(
    private builder: FormBuilder,
    private alertCtrl : AlertController,
    private params : NavParams,
    private navCtrl : NavController,
    private loadingCtrl : LoadingController,
    public viewCtrl: ViewController,
  ) {
    this.addForm = builder.group({
      'from': [moment().startOf('day').format()],
      'day': [moment().startOf('day').format()],
      'to': [moment().add(1, 'days').format()],
      'reason': ['', Validators.required],
      'kind': ['', Validators.required],
      'obs':['']
    });
    this.customer = this.params.data;
    this.today = String(moment().subtract(1, 'days').format("YYYY-MM-DD"));
    this.max = String(moment().add(1, 'year').format("YYYY-MM-DD"));
  }

  delDay(ind){
    this.days.splice(ind,1);
  }

  addDay(){
    this.days.push(moment().startOf('day').format());
  }

  save() {
    let loading = this.loadingCtrl.create({
      content: 'Guardando los cambios...'
    });
    loading.present();

    let tosave = {
      "origin" : "web",
      "datetime" : firebase.database.ServerValue.TIMESTAMP,
      "reason" : this.addForm.value.reason,
      "obs" : this.addForm.value.obs,
      "status" : 0,
      "owner" : Params.md5(Params.USER_DATA.email)
    }

    let k = this.addForm.value.kind;

    if(k==1){
      const dateString = this.addForm.value.day.substr(0,10);
      const c = moment(dateString);
      let path = 'cancellations/'+c.format('YYYYMMDD')+'/'+Params.md5(this.customer.email);

      firebase.database().ref(path).set(tosave).then(()=>{
        console.log("cancellation ok")
        this.viewCtrl.dismiss();
        loading.dismiss();
      }).catch((e)=>{
        console.log("error cancellation",e);
      })
    }

    if(k==2){
      let b = moment(this.addForm.value.from.substr(0,10));
      let a = moment(this.addForm.value.to.substr(0,10));
      let diff = a.diff(b, 'days');
      if(a>=b){
        let days_ok = 0;
        for(let i=0;i<diff;i++){
          let c = moment(this.addForm.value.from.substr(0,10)).add(i,'days');
          let path = 'cancellations/'+c.format('YYYYMMDD')+'/'+Params.md5(this.customer.email);
          console.log("cancellate ",path);

          firebase.database().ref(path).set(tosave).then(()=>{
            days_ok++;
            if(days_ok==diff){
              this.viewCtrl.dismiss();
              loading.dismiss();
            }
          })
        }
      }else{
        let config = {
          title: 'Error',
          message: "La fecha de retorno no puede ser menor a la de inicio",
          buttons: [
            {
              text: 'Ok',
              handler: data => {
                console.log('Cancel clicked');
              }
            }
          ]
        }
        let prompt = this.alertCtrl.create(config);
        prompt.present();
      }
    }

    if(k==3){
      console.log(this.days);
      for(let i=0;i<this.days.length;i++){
        let c = moment(this.days[i].substr(0,10));
        let path = 'cancellations/'+c.format('YYYYMMDD')+'/'+Params.md5(this.customer.email);
        console.log("cancellate ",path);
        firebase.database().ref(path).set(tosave).then(()=>{
          this.viewCtrl.dismiss();
          loading.dismiss();
        })
      }
    }


  }

}



// WEBPACK FOOTER //
// ./src/pages/cancellations/cancellate.ts